<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div style="display: flex; align-items: center;">
      <el-button
        icon="el-icon-back"
        @click="() => handleList()"
      >
        Danh sách
      </el-button>
      <h1 class="card-container__title ml-m">
        {{ title }}
      </h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="!isEdit && permission.UPDATE"
        type="primary"
        size="medium"
        icon="el-icon-edit"
        @click="() => $emit('edit')"
      >
        Chỉnh sửa
      </el-button>
      <el-button
        v-if="isEdit"
        type="danger"
        size="medium"
        icon="el-icon-close"
        :disabled="calling"
        @click="() => $emit('cancel')"
      >
        Hủy
      </el-button>
      <el-button
        v-if="isEdit"
        type="primary"
        size="medium"
        icon="el-icon-check"
        :loading="calling"
        @click="() => $emit('save')"
      >
        Lưu
      </el-button>
      <el-button
        class="ml-s"
        type="primary"
        size="medium"
        icon="el-icon-link"
        :plain="true"
        :disabled="calling"
        @click="handleConnection(item)"
        >Danh sách liên kết</el-button
      >
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "CardHeader",
  props: {
    isEdit: Boolean,
    item: Object,
    calling: Boolean,
    permission: Object,
    config: Object,
  },
  data() {
    return {
    }
  },
  computed: {
    title() {
      return (
        this.item?.extra?.name
      );
    },
  },
  methods: {
    handleList() {
      this.$router.push({
        name: `${this.config.extra.key}`,
      })
    },
    handleConnection(item) {
      this.$router.push({
        name: `${this.config.extra.key}_connection`,
        params: { id: item.id },
      })
    },
  }
};
</script>

<style lang="scss" scoped></style>
